export default {
  inject: ['load'],
  data() {
    return {
      allActiveMissionOtherOrganizations: [],
    };
  },
  methods: {
    getAllActiveMissionOtherOrganizations: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllActiveMissionOtherOrganizations').then(() => {
        if (this.$store.state.missionOtherOrganizationModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.allActiveMissionOtherOrganizations =
            this.$store.state.missionOtherOrganizationModule.allActiveMissionOtherOrganizations;
          if (this.$route.name == 'otherOrganizationMissions') {
            this.makeDataReady(this.allActiveMissionOtherOrganizations);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionOtherOrganizationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.missionOtherOrganizationModule.successFlag) {
                this.getAllActiveMissionOtherOrganizations();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionOtherOrganizationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllActiveMissionOtherOrganizations();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.missionOtherOrganizationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
